import PropTypes from 'prop-types';
import React, {Component} from 'react';
import Paper from 'material-ui/Paper';
import * as Colors from 'material-ui/styles/colors';
import {connect} from 'react-redux';
import Toggle from 'material-ui/Toggle';
import {setTemplateTagSetId} from 'MyAccount/ViewDesigns/helpers/preferencesHelper';
import {setSelectedTemplateTagSetId} from 'MyAccount/ViewDesigns/redux/modules/accountPage';
import InlineButton from 'shared/components/InlineButton';
import ChildrenFader from 'shared/components/ChildrenFader';
import {HoverMixin} from 'shared/helpers/mixins';
import {doGlobalUpdate} from 'MyAccount/ViewDesigns/redux/modules/globalUpdate';
import EcomdashKeyDialog from './EcomdashKeyDialog';
import {getIsAdmin} from 'crazyEditor/redux/modules/user/userSelectors';
import _ from 'lodash';

const BULK_REVISE_TEMPLATE_TAG_SET_ID = 999;

const styles = {
  container: {
    width: 190,
    height: 250,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'center',
    color: Colors.grey700,
    fontSize: 24,
    margin: 10,
  },
};

function isEcomaash(templateTagSet) {
  return templateTagSet.name && templateTagSet.name.toLowerCase() === 'ecomdash';
}

@connect(
  state => ({
    selectedTemplateTagSetId: state.accountPage.selectedTemplateTagSetId,
    dontShowBulk: !getIsAdmin(state),
  }),
  {setSelectedTemplateTagSetId, doGlobalUpdate}
)
export default class Integration extends Component {
  state = {
    hovered: false,
    ecomdashDialogOpen: false,
  };

  updateTemplateTagSet = event => {
    const {setSelectedTemplateTagSetId, templateTagSet, doGlobalUpdate, dontShowBulk} = this.props;
    const disabledIntegrationId = dontShowBulk ? BULK_REVISE_TEMPLATE_TAG_SET_ID : null;
    const id = event.target.checked ? templateTagSet.id : disabledIntegrationId;
    if (id && isEcomaash(templateTagSet)) {
      this.setState({ecomdashDialogOpen: true});
    } else {
      setTemplateTagSetId(id).then(response => {
        if (id) {
          this.enableTemplateTagSet();
        } else {
          this.disableTemplateTagSet();
        }
        if (response.success) {
          _.defer(() => {
            const {templateTagSet} = response;
            doGlobalUpdate({templateTagSet: {$set: templateTagSet}});
          });
        }
      });
      setSelectedTemplateTagSetId(id);
    }
  };

  disableTemplateTagSet() {
    const {onChangeWithMessage} = this.props;
    window.analytics.identify({'Listing Solution': 'None'});
    onChangeWithMessage(
      <span>
        Your templates are now 100% compliant for publishing <b>directly to eBay</b>
      </span>
    );
  }

  enableTemplateTagSet() {
    const {templateTagSet, onChangeWithMessage} = this.props;
    window.analytics.identify({'Listing Solution': templateTagSet.name});
    onChangeWithMessage(
      <span>
        Your templates are now 100% compliant with <b>{templateTagSet.name}</b>
      </span>
    );
  }

  render() {
    const {templateTagSet, selectedTemplateTagSetId, dontShowBulk} = this.props;
    if (dontShowBulk && templateTagSet.id === BULK_REVISE_TEMPLATE_TAG_SET_ID) {
      return null;
    }
    const {hovered, ecomdashDialogOpen} = this.state;
    const checked = selectedTemplateTagSetId === templateTagSet.id;
    return (
      <Paper
        id={`cla-integration-${templateTagSet.id}`}
        style={styles.container}
        onMouseEnter={HoverMixin.onMouseEnter.bind(this)}
        onMouseLeave={HoverMixin.onMouseLeave.bind(this)}
      >
        <div
          className={'cla-integration-title'}
          style={{marginTop: 20, height: 50, textAlign: 'center', paddingLeft: 20, paddingRight: 20, width: '100%'}}
        >
          <img
            className={'cla-integration-logo'}
            src={templateTagSet.logo}
            style={{marginBottom: 5, maxWidth: '100%', maxHeight: 48}}
          />
        </div>
        <div
          className={'cla-integration-tagline'}
          style={{
            textTransform: 'uppercase',
            fontSize: 10,
            textAlign: 'center',
            paddingLeft: 20,
            paddingRight: 20,
            width: '100%',
            position: 'relative',
            top: -8,
            height: 13,
          }}
        >
          {templateTagSet.tagLine}
        </div>
        <div className={'cla-integration-name'}>{templateTagSet.name}</div>
        <ChildrenFader
          style={{height: 32, transform: 'translateY(0px)', opacity: 1}}
          leaveStyle={{transform: 'translateY(10px)', opacity: 0}}
          transitionDurationMs={200}
          path={hovered}
        >
          {hovered && templateTagSet.link && (
            <InlineButton
              className={'cla-integration-button-guide'}
              href={templateTagSet.link}
              hoverColor="transparent"
              target="_blank"
            >
              <span style={{fontSize: 16}}>Step by step guide</span>
            </InlineButton>
          )}
        </ChildrenFader>
        <div style={{marginBottom: 20, marginTop: 7}}>
          <Toggle className={'cla-integration-toggle'} toggled={checked} onToggle={this.updateTemplateTagSet} />
        </div>
        {isEcomaash(templateTagSet) && (
          <EcomdashKeyDialog
            open={ecomdashDialogOpen}
            templateTagSetId={templateTagSet.id}
            onClose={keyValid => {
              const {templateTagSet, setSelectedTemplateTagSetId} = this.props;
              this.setState({ecomdashDialogOpen: false});
              if (keyValid) {
                setTemplateTagSetId(templateTagSet.id).then(() => {
                  this.enableTemplateTagSet();
                });
                setSelectedTemplateTagSetId(templateTagSet.id);
              }
            }}
          />
        )}
      </Paper>
    );
  }
}

Integration.propTypes = {
  onChangeWithMessage: PropTypes.func.isRequired,
};
